<template>
  <base-query class="current-voyage">
    <el-form slot="searchBox" size="mini" label-width="70px">
      <div class="content-body">
        <div class="contentLeft">
          <el-row>
            <el-col style="width: 18%">
              <el-form-item label="MMSI">
                <el-input
                  v-model="form.mmsi"
                  clearable
                  style="width: 100%"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>

            <el-col style="width: 18%">
              <el-form-item label="船名">
                <el-select
                  v-model="form.shipid"
                  style="width: 100%"
                  clearable
                  filterable
                  remote
                  placeholder="请输入"
                  :remote-method="remoteMmsiForShipName"
                  :loading="optloading"
                  @focus="remoteMmsiForShipName()"
                  @change="onShipChange"
                >
                  <el-option
                    v-for="item in shiplist"
                    :key="item.id"
                    :label="item.nameEn"
                    :value="item.id"
                  >
                    {{ item.nameEn }}({{ item.mmsi }})
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col style="width: 18%">
              <el-form-item label="事件类型">
                <el-select
                  v-model="form.eventType"
                  clearable
                  placeholder="请输入"
                >
                  <el-option
                    v-for="item in eventtypes"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col style="width: 18%">
              <el-form-item label="更新时间">
                <el-date-picker
                  v-model="form.btm"
                  clearable
                  type="datetime"
                  style="width: 100%"
                  placeholder="开始日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
            </el-col>
            <el-col style="width: 18%">
              <el-form-item label="——">
                <el-date-picker
                  v-model="form.etm"
                  clearable
                  style="width: 100%"
                  type="datetime"
                  placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="contenRight">
          <el-tooltip :content="`${updateMissingCount}条更新失败事件`">
            <i
              v-if="updateMissingCount"
              class="el-icon-warning"
              style="
                color: #e6a23c;
                font-size: 2em;
                cursor: pointer;
                margin-right: 10px;
              "
            ></i>
          </el-tooltip>

          <el-button
            size="mini"
            class="serachBtn"
            :loading="isloading"
            @click="listCurrentVoyageList(1)"
          >
            搜索
          </el-button>
        </div>
      </div>
    </el-form>

    <div style="text-align: right; margin: 0 0 5px 0">
      <!-- <el-button size="mini" type="text" style="margin-right: 5px">批量更新</el-button> -->
      <el-tooltip
        placement="left"
        :disabled="!numOfPendingUpdates.length"
        popper-class="voyage-updated-queue-list"
      >
        <div slot="content">
          <div
            v-for="item in numOfPendingUpdates"
            :key="item[0]"
            class="queue-item"
            :class="{ 'active-queue': item[2] }"
          >
            <span class="queue-item__key">{{ item[0] }}</span>
            <span>: {{ item[1] }}</span>
          </div>
        </div>
        <el-button size="mini" type="text" style="margin-right: 5px">
          更新状态
        </el-button>
      </el-tooltip>

      <el-button size="mini" type="text" @click="historyVoyageF = true">
        历史挂靠
      </el-button>
    </div>

    <el-table
      ref="table"
      v-loading="isloading"
      :data="voyagelist"
      size="mini"
      height="550"
      max-height="550"
      row-key="id"
      class="voyage-table"
      :border="false"
    >
      <el-table-column
        prop="mmsi"
        label="MMSI"
        width="100"
        align="center"
        fixed="left"
      >
        <div slot-scope="scope" style="text-align: center">
          <span
            :title="statTitle(scope.row.mmsi)"
            :class="{ 'has-history': historyStat[scope.row.mmsi] }"
          >
            {{ scope.row.mmsi }}
          </span>
        </div>
      </el-table-column>

      <el-table-column label="出发港" align="center">
        <el-table-column
          prop="departureName"
          label="港口名称"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.departureName }}
            <span
              v-if="scope.row.portCode1"
              style="color: #999; margin-left: 5px"
              >({{ scope.row.portCode1 }})</span
            >
          </template>
        </el-table-column>

        <el-table-column prop="departureTime" label="离港时间" width="150" />

        <el-table-column
          prop="departureTimeZone"
          label="时区"
          width="50"
          align="center"
        />
      </el-table-column>

      <el-table-column label="到达港" align="center">
        <el-table-column
          prop="arrivalPortName"
          label="港口名称"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.arrivalPortName }}
            <span
              v-if="scope.row.portCode0"
              style="color: #999; margin-left: 5px"
              >({{ scope.row.portCode0 }})</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="atPortArrival" label="到港时间" width="150" />

        <el-table-column
          prop="arrivalTimeZone"
          label="时区"
          width="50"
          align="center"
        />
      </el-table-column>

      <!-- <el-table-column label="锚地" align="center">
                <el-table-column prop="atAnchorArrival" label="实际到锚时间" width="150">

                </el-table-column>

                <el-table-column prop="atAnchorDeparture" label="实际离锚时间" width="150">

                </el-table-column>

                <el-table-column prop="timeInAnchor" label="实际在锚时⻓" width="100">

                </el-table-column>
            </el-table-column> -->

      <el-table-column label="泊位" align="center">
        <el-table-column
          prop="atBerthArrival"
          label="实际到泊时间"
          width="150"
        />

        <el-table-column
          prop="atBerthDeparture"
          label="实际离泊时间"
          width="150"
        />

        <el-table-column prop="timeInBerth" label="实际在泊时⻓" width="100" />
      </el-table-column>

      <el-table-column
        prop="updateTime"
        label="更新时间"
        width="150"
        align="center"
      />

      <el-table-column prop="eventType" label="事件类型" width="80">
        <div slot-scope="scope" class="voyage-event-type">
          <span
            v-if="scope.row.isUpdateMissing"
            style="margin-right: 5px"
            title="缺失更新"
          >
            <i
              class="el-icon-error"
              style="font-size: 1.5em; color: #f56c6c"
            ></i>
          </span>
          <span
            v-else-if="scope.row.manual"
            style="margin-right: 5px"
            title="手动更新"
          >
            <i
              class="el-icon-success"
              style="font-size: 1.5em; color: #67c23a"
            ></i>
          </span>
          <span>{{ scope.row.eventType | eventTypeConv }}</span>
        </div>
      </el-table-column>

      <el-table-column
        prop="eventTime"
        label="事件时间"
        width="150"
        align="center"
      />

      <el-table-column label="操作" width="80" align="center" fixed="right">
        <div slot-scope="scope" style="width: 100%; text-align: center">
          <el-button
            type="text"
            size="mini"
            :loading="scope.row.isloading"
            @click="updateCurrentVoyage0(scope.row)"
          >
            更新
          </el-button>
        </div>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="total,prev,pager,next"
      :total="total"
      :page-size="50"
      :current-page.sync="num"
      class="pagination"
      @current-change="listCurrentVoyageList"
    />

    <el-dialog :visible.sync="historyVoyageF" append-to-body width="40%">
      <history-voyage-dialog />
    </el-dialog>
  </base-query>
</template>

<script>
import BaseQuery from '@/components/BaseQuery.vue'
import api from './api'
import HistoryVoyageDialog from './HistoryVoyageDialog.vue'

const typeDesc = '2:离港,5:进泊,127:驳船更新,128:失败重试'
  .split(',')
  .map(k => k.split(':'))
  .reduce((prev, curr) => ((prev[curr[0]] = curr[1]), prev), {})

export default {
  components: {
    BaseQuery,
    // AisEventLookDialog,
    HistoryVoyageDialog,
  },

  filters: {
    eventTypeConv(type) {
      return typeDesc[type] || '未知'
    },
  },

  mixins: [api],

  data() {
    const eventtypes = []

    const keys = Object.keys(typeDesc)
    keys.sort()

    for (const k of keys) {
      eventtypes.push({
        id: k,
        value: typeDesc[k],
      })
    }

    return {
      historyVoyageF: false,
      eventtypes,
      voyagelist: [],

      form: {
        mmsi: '',
        shipid: '',
        eventType: '',
        btm: '',
        etm: '',
      },

      num: 1,

      total: 0,

      updateMissingCount: 0,

      isloading: false,
      optloading: false,
      shiplist: [],
      historyStat: {},

      numOfPendingUpdates: [],
    }
  },

  mounted() {
    //    this.listCurrentVoyageList()
    //    this.$on('activate', this.listCurrentVoyageList)

    let timer

    let loadPendingUpdates = async () => {
      const resp = await this.$api.get(
        '/trace/aiseventops/numOfPendingUpdates',
        { baseURL: '/' }
      )

      if (resp.data.status === 1) {
        const data = resp.data.content || {},
          current = data['Index'],
          results = []

        Object.keys(data).forEach(k => {
          if (k !== 'Index') {
            results.push([k, data[k], current === k])
          }
        })

        this.numOfPendingUpdates = results
      }

      timer = setTimeout(async () => await loadPendingUpdates(), 1000 * 10)
    }

    loadPendingUpdates()

    this.$once('destroyed', () => clearInterval(timer))
  },

  destroyed() {
    this.$emit('destroyed')
  },

  methods: {
    statTitle(mmsi) {
      const stat = this.historyStat[mmsi]

      if (stat) {
        return `历史挂靠收集, 数量: ${stat.count}, 最小ATA: ${stat.minAta}, 最大ATA: ${stat.maxAta}`
      }
    },

    async queryHistoryVoyageStat0() {
      this.historyStat = {}
      const ms = (this.voyagelist || []).map(it => it.mmsi)

      if (!ms.length) {
        return
      }
      try {
        const resp = await this.queryHistoryVoyageStat(ms)
        const data = {}
        if (resp.data.status === 1) {
          ;(resp.data.content || []).forEach(it => {
            data[it.mmsi] = it
          })
        }
        this.historyStat = data
      } catch (e) {
        console.error(e)
      }
    },

    async listCurrentVoyageList(num) {
      const mmsi = this.form.mmsi

      if (mmsi && !/^\d{9}$/.test(mmsi)) {
        return this.$message.error('mmsi格式不正确')
      }

      this.isloading = true

      try {
        const body = {
          num: num || 1,
          mmsi,
          eventType: this.form.eventType,
          btm: this.form.btm,
          etm: this.form.etm,
        }

        const [resp0, resp1] = await Promise.all([
          this.$api.post('/trace/aiseventops/listCurrentVoyage', body, {
            baseURL: '/',
          }),
          this.$api.get('/trace/aiseventops/updateMissingCount', {
            baseURL: '/',
          }),
        ])

        if (resp0.data.status === 1) {
          this.voyagelist = resp0.data.content.list || []
          this.total = resp0.data.content.total
          this.num = resp0.data.content.pageNum

          if (resp1.data.status === 1) {
            this.updateMissingCount = resp1.data.content || 0
          }

          this.queryHistoryVoyageStat0()
        } else {
          return this.$message.error(resp0.data.message || '获取挂靠列表错误')
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.isloading = false
      }
    },

    async updateCurrentVoyage0(row) {
      const mmsi = row.mmsi

      if (!/^\d{9}$/.test(mmsi)) {
        return this.$message.error('mmsi格式不正确')
      }
      this.$set(row, 'isloading', true)
      try {
        const voyage = await this.updateCurrentVoyage(mmsi)
        Object.keys(voyage).forEach(key => this.$set(row, key, voyage[key]))
      } catch (e) {
        this.$message.error(typeof e === 'string' ? e : '更新当前挂靠错误')
      } finally {
        this.$set(row, 'isloading', false)
      }
    },

    async remoteMmsiForShipName(name) {
      this.optloading = true
      try {
        this.shiplist = await this.getVesselByName(name)
      } catch (e) {
        this.$message.error(e)
      } finally {
        this.optloading = false
      }
    },

    onShipChange(shipid) {
      const item = this.shiplist.find(it => it.id === shipid) || {}
      this.form.mmsi = item.mmsi || ''
    },
  },
}
</script>

<style lang="scss">
.voyage-updated-queue-list {
  max-height: none;
  .queue-item {
    &.active-queue {
      color: aquamarine;
    }

    .queue-item__key {
      font-weight: 400;
    }
    padding: 3px;
  }
}
</style>

<style lang="scss" scoped>
.current-voyage {
  padding: 0;

  .voyage-table {
    ::v-deep thead.is-group th.el-table__cell {
      background-color: inherit;
    }

    .voyage-event-type {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }

    .has-history {
      transition: all 0.2s;
      color: #5a003c;
      font-weight: bold;
    }
  }

  .pagination {
    text-align: right;
    padding: 10px 0;
  }

  .serachBtn {
    padding: 9px 35px;
    color: #fff;
    background-color: rgba(4, 153, 255, 1);
    border: 1px solid #3bafda;
  }

  .content-body {
    padding: 10px 0;

    display: flex;
    flex-direction: row;
    align-items: center;

    ::v-deep .el-form-item {
      margin-bottom: 0;
    }
  }

  .contentLeft {
    flex-grow: 1;
  }

  .contenRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: right;
  }

  ::v-deep .el-row .el-col:nth-last-of-type(1) {
    margin-right: 0;
  }

  ::v-deep .el-col {
    margin-right: 20px;
  }

  label:nth-of-type(2) {
    width: 10px !important;
  }

  .buttonTop {
    margin-bottom: 20px;

    .clickColor {
      background-color: #fff;
      padding: 9px 15px;
      margin-right: 10px;
    }

    .teshunormal {
      color: #3bafda;
      border: 1px solid #3bafda;
      width: 80px;
      cursor: pointer;
      background: #fff;
      text-align: center;
      margin-right: 20px;
    }
  }
}
</style>
